"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var onImageLoad = function onImageLoad($image, callback) {
  if ($image.length === 0) {
    callback();
  }

  if ($image[0].complete) {
    callback();
  } else {
    var src = $image.attr('src');
    $image[0].onload = callback;
    $image.attr('src', src);
    setTimeout(function () {
      if ($image[0].complete) {
        callback();
      }
    }, 100);
  }
};

var _default = onImageLoad;
exports["default"] = _default;